import i18next, { t } from "i18next";
import pluralize from "pluralize";

export function smartPluralize(
	singular: string,
	count: number,
	options?: { language?: string },
) {
	const language = options?.language || i18next.language;

	if (language === "en-US") {
		return pluralize(t(`common.${singular}`), count);
	}
	return t(`common.${singular}`, { count });
}
